import { useTranslation } from 'react-i18next'

import { NewsboardPostAction } from '../NewsboardPostAction'

import { POST_REPORTS_VIEWS_TAB } from './NewsboardPostReportsTableModal'

import ReportIcon from '../../../../../icons/report.svg'

function NewsboardPostReport({ onOpenReport }) {
  const { t } = useTranslation()

  function handleOpenReport() {
    onOpenReport(POST_REPORTS_VIEWS_TAB)
  }

  return (
    <NewsboardPostAction
      Icon={ReportIcon}
      title={t('Newsboard.ReportsActionKey')}
      onClick={handleOpenReport}
    />
  )
}

export default NewsboardPostReport
